/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Calendar,
  Video,
  Headphones,
  Users,
  BookOpen,
  Heart,
  DollarSign,
  Sparkles,
  MessageCircle,
  Mic,
  ExternalLink,
  Brain,
  Dumbbell,
  Compass,
  Landmark,
  ArrowRight,
  Check,
  Flame,
  CalendarCheck,
  Quote,
} from 'lucide-react';
import PortalSubPage, { ComingSoonCard } from '../PortalSubPage';
import {
  NEXT_MEETING,
  INTEREST_MAILTO,
  INTEREST_EMAIL,
  CIRCLE_FOCUS,
  CIRCLE_GUEST_SPEAKER,
  CIRCLE_TOPICS,
  CIRCLE_PRICE,
  getReflectionForOffset,
} from '../../data/portalData';

export function PortalHealth() {
  const pillars = [
    { name: 'Stillness', desc: 'Time in silence, without input' },
    { name: 'Sleep', desc: '7\u20138 hours, protected' },
    { name: 'Support', desc: 'The brothers who see you' },
    { name: 'Strength', desc: 'Move under load, twice weekly' },
    { name: 'Steps', desc: 'Walk daily, no tech' },
    { name: 'Sitting', desc: 'Stand every 45 minutes' },
    { name: 'Silence', desc: 'Meditate, even for five minutes' },
    { name: 'Smiling', desc: 'Joy is a discipline' },
  ];
  return (
    <PortalSubPage
      eyebrow="Body &middot; Breath &middot; Sleep"
      title={<>The <span className="italic text-[#D4AF37]">S&rsquo;s</span> of Self-Care.</>}
      intro="David Girton's eight-pillar framework. Track one each day. Small, repeatable, life-changing."
      icon={Heart}
    >
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {pillars.map((p) => (
          <div
            key={p.name}
            className="rounded-xl bg-[#111111] border border-white/10 p-4 hover:border-[#D4AF37]/30 transition-colors"
          >
            <p className="text-[#D4AF37] font-cormorant text-2xl font-medium">{p.name}</p>
            <p className="text-zinc-500 font-manrope text-xs mt-1">{p.desc}</p>
          </div>
        ))}
      </div>
      <ComingSoonCard note="Workout plans, sleep protocols, and breathwork sessions from David G. are coming soon." />
    </PortalSubPage>
  );
}
